export default {
  'pages.appStore.refresh': '刷新',
  'pages.appStore.install': '部署',
  'pages.appStore.cancel': '取消',
  'pages.appStore.confirmInstall': '部署到集群',
  'pages.appStore.installCount': '已部署 {count} 次',
  'pages.appStore.spec':
    '{cpu} 核 CPU · {memory} MiB 内存 · {storage} GiB 存储',
  'pages.appStore.installTitle': '部署 {name}',
  'pages.appStore.installSuccess': '部署「{name}」已提交',
  'pages.appStore.installSuccessDescription':
    '服务正在企业集群中创建，通常需要一到两分钟完成启动，可在我的部署中查看运行状态与访问地址。',
  'pages.appStore.continueBrowsing': '继续浏览',
  'pages.appStore.viewDeployments': '查看我的部署',
  'pages.appStore.title': '部署模板',
  'pages.appStore.description':
    '一键将数据库、缓存、运维工具等云原生应用部署到企业专属集群，开箱即用。',
  'pages.appStore.searchPlaceholder': '搜索名称、标签或描述',
  'pages.appStore.empty': '没有找到匹配的应用',
  'pages.appStore.allCategories': '全部',
  'pages.appStore.category.database': '数据库',
  'pages.appStore.category.cache': '缓存',
  'pages.appStore.category.storage': '存储',
  'pages.appStore.category.messaging': '消息队列',
  'pages.appStore.category.devtools': '开发工具',
  'pages.appStore.category.monitoring': '监控运维',
  'pages.appStore.category.other': '其它',
  'pages.appStore.field.name': '部署名称',
  'pages.appStore.field.nameHelp': '同时作为集群内的服务名，部署后不可修改。',
  'pages.appStore.field.nameRequired': '请输入部署名称',
  'pages.appStore.field.nameInvalid':
    '只能包含小写字母、数字和中划线，以字母开头，长度不超过 40',
  'pages.appStore.field.description': '描述',
  'pages.appStore.field.inputs': '初始化参数',
  'pages.appStore.field.inputRequired': '请填写{label}',
  'pages.appStore.deployments.title': '我的部署',
  'pages.appStore.deployments.description':
    '查看已部署到企业集群的应用与服务，支持公网与内网访问。',
  'pages.appStore.deployments.name': '部署名称',
  'pages.appStore.deployments.type': '类型/来源',
  'pages.appStore.deployments.status': '状态',
  'pages.appStore.deployments.endpoint': '访问地址',
  'pages.appStore.deployments.spec': '规格',
  'pages.appStore.deployments.createdBy': '部署人',
  'pages.appStore.deployments.createdAt': '部署时间',
  'pages.appStore.deployments.actions': '操作',
  'pages.appStore.deployments.delete': '删除',
  'pages.appStore.deployments.deleteTitle': '删除部署「{name}」？',
  'pages.appStore.deployments.deleteDescription':
    '会同时删除数据卷且不可恢复。',
  'pages.appStore.deployments.empty': '还没有任何部署',
  'pages.appStore.deployments.installFromStore': '从部署模板安装',
  'pages.appStore.deployments.customDeploy': '自定义部署',
  'pages.appStore.deployments.customTag': '自定义',
  'pages.appStore.deployments.publicLink': '公网访问',
  'pages.appStore.deployments.internalPrefix': '内网',
  'pages.appStore.status.running': '运行中',
  'pages.appStore.status.pending': '启动中',
  'pages.appStore.status.failed': '异常',
  'pages.appStore.status.stopped': '未运行',
  'pages.appStore.status.unknown': '集群未接入',
  'pages.appStore.status.paused': '已暂停',
  'pages.appStore.deployments.edit': '变更',
  'pages.appStore.deployments.more': '更多',
  'pages.appStore.deployments.restart': '重启',
  'pages.appStore.deployments.pause': '暂停',
  'pages.appStore.deployments.start': '启动',
  'pages.appStore.deployments.autoscalingTag': '弹性 {min}~{max}',
  'pages.appStore.deployments.restartTitle': '重启部署「{name}」？',
  'pages.appStore.deployments.restartDescription':
    '所有实例会滚动重建，期间服务可能短暂不可用。',
  'pages.appStore.deployments.restartDone': '部署「{name}」正在重启',
  'pages.appStore.deployments.pauseTitle': '暂停部署「{name}」？',
  'pages.appStore.deployments.pauseDescription':
    '所有实例会被停止，访问地址暂不可用；配置和数据卷会保留，可随时启动。',
  'pages.appStore.deployments.pauseDone': '部署「{name}」已暂停',
  'pages.appStore.deployments.startTitle': '启动部署「{name}」？',
  'pages.appStore.deployments.startDescription':
    '按暂停前的实例数和弹性伸缩配置恢复运行。',
  'pages.appStore.deployments.startDone': '部署「{name}」正在启动',
  'pages.appStore.deployments.deleteDone': '部署「{name}」已删除',
  'pages.appStore.form.createTitle': '应用部署',
  'pages.appStore.form.editTitle': '变更部署 · {name}',
  'pages.appStore.form.exportYaml': '导出 YAML',
  'pages.appStore.form.submitUpdate': '确认变更',
  'pages.appStore.form.viewForm': '配置表单',
  'pages.appStore.form.viewYaml': 'YAML 文件',
  'pages.appStore.form.copyYaml': '复制 YAML',
  'pages.appStore.form.copied': '已复制',
  'pages.appStore.form.section.basic': '基础信息',
  'pages.appStore.form.section.resource': '资源配置',
  'pages.appStore.form.section.network': '网络配置',
  'pages.appStore.form.section.advanced': '高级配置',
  'pages.appStore.form.summaryTitle': '资源汇总',
  'pages.appStore.form.summaryInstances': '实例数',
  'pages.appStore.form.summaryStorage': '存储卷',
  'pages.appStore.form.enabled': '已开启',
  'pages.appStore.form.disabled': '未开启',
  'pages.appStore.form.cores': '{value} 核',
  'pages.appStore.form.scalingMode': '实例',
  'pages.appStore.form.scalingFixed': '固定实例',
  'pages.appStore.form.scalingAuto': '弹性伸缩',
  'pages.appStore.form.instances': '实例数',
  'pages.appStore.form.autoTarget': '目标值',
  'pages.appStore.form.autoTargetCpuHint':
    '当实例平均 CPU 使用量超过上限的该比例时自动扩容，低于时缩容。',
  'pages.appStore.form.autoTargetMemoryHint':
    '当实例平均内存使用量超过上限的该比例时自动扩容，低于时缩容。',
  'pages.appStore.form.instanceRange': '实例范围',
  'pages.appStore.form.instanceRangeInvalid': '最大实例数不能小于最小实例数',
  'pages.appStore.form.sharedVolumeNoAuto':
    '旧版本创建的带存储部署不支持弹性伸缩',
  'pages.appStore.form.sharedVolumeSingle':
    '该部署创建于旧版本，所有实例共用同一个存储卷，只能运行 1 个实例。',
  'pages.appStore.form.networkHint':
    '部署后会自动生成集群内访问地址；HTTP 端口可开启公网访问并自动签发 HTTPS 证书。',
  'pages.appStore.form.containerPort': '容器端口',
  'pages.appStore.form.namePlaceholderHost': '<部署名称>',
  'pages.appStore.form.commandHint': '不填写时使用镜像默认的启动命令。',
  'pages.appStore.form.commandPlaceholder': '例如：/bin/sh -c',
  'pages.appStore.form.argsPlaceholder': '例如：sleep 10 && /entrypoint.sh',
  'pages.appStore.form.add': '新增',
  'pages.appStore.form.envBulkEdit': '批量编辑',
  'pages.appStore.form.envBulkTitle': '编辑环境变量',
  'pages.appStore.form.envBulkPlaceholder':
    '每行一个环境变量，用等号或冒号分隔，例如：\nmongoUrl=127.0.0.1:8000\nredisUrl:127.0.0.1:8001\n- env1=test',
  'pages.appStore.form.envBulkInvalid':
    '第 {lines} 行的变量名不合法：只能包含字母、数字和下划线，且不能以数字开头',
  'pages.appStore.form.envBulkCount':
    '共 {count} 个环境变量，保存后会替换当前列表',
  'pages.appStore.form.localStorage': '本地存储',
  'pages.appStore.form.storageHint':
    '每个实例各自挂载一份独立的存储卷，实例之间数据不互通。',
  'pages.appStore.form.storageImmutable': '存储卷创建后不可修改。',
  'pages.appStore.form.perInstanceVolume':
    '多实例时每个实例各有一份独立的存储卷，实例之间数据不互通，请确认应用支持这种部署方式。',
  'pages.appStore.form.addVolumeTitle': '新增存储卷',
  'pages.appStore.form.volumeSize': '容量',
  'pages.appStore.form.volumeSizeRange': '容量范围：1–500 Gi',
  'pages.appStore.form.confirm': '确认',
  'pages.appStore.form.fixErrors': '请先修正表单中标红的内容',
  'pages.appStore.form.updateSuccess': '部署「{name}」变更已提交',
  'pages.appStore.form.loadFailed':
    '读取部署配置失败，部署可能已被删除或集群暂时不可用',
  'pages.appStore.form.backToList': '返回部署列表',
  'pages.appStore.detail.eventsTab': '事件',
  'pages.appStore.detail.noPodsPaused': '部署已暂停，可在列表的「更多」中启动',
  'pages.appStore.detail.restartPodTitle': '重启 Pod「{name}」？',
  'pages.appStore.detail.restartPodDescription':
    'Pod 会被删除并由集群自动重建。',
  'pages.appStore.detail.restartPodDone': 'Pod「{name}」正在重启',
  'pages.appStore.events.type': '类型',
  'pages.appStore.events.Warning': '警告',
  'pages.appStore.events.Normal': '正常',
  'pages.appStore.events.reason': '原因',
  'pages.appStore.events.object': '对象',
  'pages.appStore.events.message': '信息',
  'pages.appStore.events.count': '次数',
  'pages.appStore.events.lastSeen': '最近发生',
  'pages.appStore.events.warningsOnly': '只看警告',
  'pages.appStore.events.empty': '暂无事件',
  'pages.appStore.events.retentionHint': '集群默认只保留最近 1 小时的事件。',
  'pages.appStore.logs.modeLive': '实时',
  'pages.appStore.logs.modeSnapshot': '快照',
  'pages.appStore.logs.stream.connecting': '连接中',
  'pages.appStore.logs.stream.live': '实时推送中',
  'pages.appStore.logs.stream.ended': '已结束',
  'pages.appStore.logs.stream.error': '连接中断',
  'pages.appStore.logs.searchPlaceholder': '搜索关键字',
  'pages.appStore.logs.matchCount': '{count} 行匹配',
  'pages.appStore.logs.onlyMatches': '只显示匹配行',
  'pages.appStore.logs.timestamps': '显示时间',
  'pages.appStore.logs.wrap': '自动换行',
  'pages.appStore.logs.download': '下载完整日志',
  'pages.appStore.logs.downloadFailed': '下载日志失败',
  'pages.appStore.logs.fullscreen': '全屏',
  'pages.appStore.logs.exitFullscreen': '退出全屏（Esc）',
  'pages.appStore.logs.loading': '正在加载日志…',
  'pages.appStore.logs.jumpToLatest': '跳到最新',
  'pages.appStore.deployments.detail': '详情',
  'pages.appStore.deployments.scale': '伸缩',
  'pages.appStore.deployments.replicas': '{replicas} 副本',
  'pages.appStore.scale.title': '调整「{name}」副本数',
  'pages.appStore.scale.submit': '确定',
  'pages.appStore.scale.replicas': '目标副本数',
  'pages.appStore.scale.current': '当前副本数：{replicas}',
  'pages.appStore.scale.storageLimit':
    '该部署创建于旧版本，所有实例共用同一个存储卷，只能运行 1 个实例。',
  'pages.appStore.scale.success': '已将「{name}」调整为 {replicas} 个副本',
  'pages.appStore.detail.title': '部署详情 · {name}',
  'pages.appStore.detail.podsTab': 'Pod 与监控',
  'pages.appStore.detail.logsTab': '日志',
  'pages.appStore.detail.refresh': '刷新',
  'pages.appStore.detail.podName': 'Pod 名称',
  'pages.appStore.detail.podStatus': '状态',
  'pages.appStore.detail.restarts': '重启次数',
  'pages.appStore.detail.cpu': 'CPU 使用率',
  'pages.appStore.detail.memory': '内存使用率',
  'pages.appStore.detail.cpuUsage': '{used} 核 / 上限 {limit} 核',
  'pages.appStore.detail.memoryUsage': '{used} MiB / 上限 {limit} MiB',
  'pages.appStore.detail.node': '节点 / IP',
  'pages.appStore.detail.startTime': '启动时间',
  'pages.appStore.detail.viewLogs': '日志',
  'pages.appStore.detail.previousLogs': '上次运行日志',
  'pages.appStore.detail.phase.Running': '运行中',
  'pages.appStore.detail.phase.Pending': '启动中',
  'pages.appStore.detail.phase.Failed': '异常',
  'pages.appStore.detail.metricsUnavailable':
    '集群未安装 metrics-server，暂无法展示 CPU 与内存用量。',
  'pages.appStore.detail.noPods': '当前没有运行中的 Pod',
  'pages.appStore.detail.autoRefreshHint': '每 {seconds} 秒自动刷新',
  'pages.appStore.detail.tailLines': '最后 {lines} 行',
  'pages.appStore.detail.emptyLogs': '暂无日志输出',
  'pages.appStore.custom.image': '容器镜像',
  'pages.appStore.custom.imagePlaceholder':
    '如 nginx:1.27 或 harbor.3as.cn/app:v1',
  'pages.appStore.custom.imageRequired': '请输入容器镜像地址',
  'pages.appStore.custom.imageInvalid': '镜像地址不能包含空格',
  'pages.appStore.custom.memory': '内存',
  'pages.appStore.custom.replicasRequired': '请输入副本数',
  'pages.appStore.custom.addPort': '添加端口',
  'pages.appStore.custom.protocol': '协议',
  'pages.appStore.custom.publicAccess': '公网访问',
  'pages.appStore.custom.publicHttpOnly': '仅 HTTP 协议支持公网访问',
  'pages.appStore.custom.portRequired': '请输入端口号',
  'pages.appStore.custom.portDuplicate': '端口号不能重复',
  'pages.appStore.custom.envGroup': '环境变量',
  'pages.appStore.custom.envKey': '变量名',
  'pages.appStore.custom.envValue': '变量值',
  'pages.appStore.custom.envKeyInvalid':
    '以字母或下划线开头，仅包含字母数字下划线',
  'pages.appStore.custom.envKeyDuplicate': '环境变量名称不能重复',
  'pages.appStore.custom.mountPath': '挂载路径（绝对路径）',
  'pages.appStore.custom.mountPathInvalid': '必须为以 / 开头的绝对路径',
  'pages.appStore.custom.mountPathDuplicate': '挂载路径不能重复',
  'pages.appStore.custom.command': '启动命令',
  'pages.appStore.custom.args': '启动参数',
  'pages.appStore.custom.argsHelp': '容器启动参数，多个参数以空格或逗号分隔',
  'pages.appStore.custom.submit': '确认部署',
  'pages.appStore.custom.success': '自定义部署「{name}」已提交',
  'pages.appStore.custom.envKeyRequired': '请输入变量名',
  'pages.appStore.custom.mountPathRequired': '请输入挂载路径',
  'pages.appStore.deployments.emptyDescription':
    '从部署模板一键安装，或填写镜像参数自定义部署。',
  'pages.appStore.images.title': '镜像仓库',
  'pages.appStore.images.description':
    '浏览平台共享镜像仓库中的容器镜像，可直接选择标签部署到企业集群。',
  'pages.appStore.images.name': '镜像名称',
  'pages.appStore.images.searchPlaceholder': '按镜像名称搜索',
  'pages.appStore.images.address': '仓库地址',
  'pages.appStore.images.tagCount': '标签数',
  'pages.appStore.images.lastPushedAt': '最近推送',
  'pages.appStore.images.actions': '操作',
  'pages.appStore.images.viewTags': '查看标签',
  'pages.appStore.images.empty': '镜像仓库中还没有镜像',
  'pages.appStore.images.refresh': '刷新',
  'pages.appStore.images.readOnlyHint':
    '镜像仓库由平台统一管理，你可以浏览并使用这些镜像部署应用。',
  'pages.appStore.images.tag': '标签',
  'pages.appStore.images.digest': '摘要',
  'pages.appStore.images.size': '大小',
  'pages.appStore.images.pushedAt': '推送时间',
  'pages.appStore.images.lastPulledAt': '最近拉取',
  'pages.appStore.images.inUse': '使用中',
  'pages.appStore.images.inUseCount': '{count} 个部署',
  'pages.appStore.images.deploy': '部署',
  'pages.appStore.images.delete': '删除',
  'pages.appStore.images.cancel': '取消',
  'pages.appStore.images.deleteTitle': '删除镜像标签「{name}」？',
  'pages.appStore.images.deleteDescription':
    '删除后无法再拉取该标签，已拉取到节点上的副本不受影响。',
  'pages.appStore.images.deleteBlocked':
    '仍有部署在使用该标签，请先删除相关部署',
  'pages.appStore.images.deleted': '已删除 {name}',
};
